// extracted by mini-css-extract-plugin
module.exports = {"TablePagination":"style_TablePagination__dG6DB","button":"style_button__1aJN5"};